import React, { useEffect, useState } from 'react'
import { FaTrash, FaPlus } from 'react-icons/fa'
import { FaPencil } from "react-icons/fa6";
import { addUsers, getUsers, updateUser, deleteUser } from '../../Services/userService'
import toast from 'react-hot-toast'
import { useSelector } from 'react-redux'
import EditUserModal from '../../Components/Modals/EditUserModal'
import DeleteOrderModal from '../../Components/Modals/DeleteUserModal';

const User = () => {

    const [users, setUsers] = useState([])
    const [showModal, setShowModal] = useState(false)
    const [isEdit, setIsEdit] = useState(false)
    const [selectedUserId, setSelectedUserId] = useState(null)
    const [loading, setLoading] = useState(false)

    const [showDeleteModal, setShowDeleteModal] = useState(false)
    const [selectedUser, setSelectedUser] = useState(null)

    const [editData, setEditData] = useState({
        firstName: "",
        lastName: "",
        userName: "",
        password: "",
        role: "user"
    })

    const companyId = useSelector(state => state.auth.companyId);
    const companyPin = useSelector(state => state.auth.companyPin);

    const base64Pin = btoa(companyPin);

    const handleGetUserData = async () => {
        const response = await getUsers(base64Pin);
        if (response?.status === "success") setUsers(response?.data || [])
    }

    useEffect(() => { handleGetUserData() }, [])

    // ✅ ADD USER
    const handleAdd = () => {
        setIsEdit(false)
        setSelectedUserId(null)

        setEditData({
            firstName: "",
            lastName: "",
            userName: "",
            password: "",
            role: "user"
        })

        setShowModal(true)
    }

    // ✅ EDIT USER
    const handleEdit = (user) => {
        setIsEdit(true)
        setSelectedUserId(user.id)

        setEditData({
            firstName: user.firstName || "",
            lastName: user.lastName || "",
            userName: user.userName || "",
            role: user.role || "user",
            password: ""
        })

        setShowModal(true)
    }

    // ✅ SUBMIT (ADD + EDIT)
    const handleSubmit = async () => {
        if (!editData.firstName || !editData.lastName || !editData.userName) {
            toast.error("Please fill all fields")
            return
        }

        if (!isEdit && !editData.password) {
            toast.error("Password required")
            return
        }

        setLoading(true)

        const body = {
            ...editData,
            company_id: companyId,
            company_pin: companyPin
        }

        let response

        if (isEdit) {
            response = await updateUser(selectedUserId, body)
        } else {
            response = await addUsers(body)
        }

        setLoading(false)

        if (response?.status === "success") {
            toast.success(response.message)
            setShowModal(false)
            handleGetUserData()
        } else {
            toast.error(response?.message || "Something went wrong")
        }
    }

    const handleDelete = async (id) => {
        const response = await deleteUser(id);
        if (response?.status === "success") {
            toast.success(response?.message || "User deleted");
            handleGetUserData();
        } else toast.error(response?.message || "Delete failed");
    };

    const handleConfirmDelete = async () => {
        if (!selectedUser) return

        setLoading(true)

        const response = await deleteUser(selectedUser.id)

        setLoading(false)

        if (response?.status === "success") {
            toast.success(response?.message || "User deleted")
            setShowDeleteModal(false)
            setSelectedUser(null)
            handleGetUserData()
        } else {
            toast.error(response?.message || "Delete failed")
        }
    }

    return (
        <div>

            {/* HEADER */}
            <div className="d-flex justify-content-between mb-3">
                <h4>Users</h4>

                <button className="oms-btn oms-btn-primary" onClick={handleAdd}>
                    <FaPlus size={12} /> Add User
                </button>
            </div>

            {/* TABLE */}
            <div className="oms-table-wrap">
                {users.length === 0 ? (
                    <div className="oms-empty">No users found</div>
                ) : (
                    <table>
                        <thead>
                            <tr>
                                <th>#</th>
                                <th>First Name</th>
                                <th>Last Name</th>
                                <th>User Name</th>
                                <th>Company Pin</th>
                                <th>Role</th>
                                <th>Action</th>
                            </tr>
                        </thead>

                        <tbody>
                            {users.map((user, index) => (
                                <tr key={user.id}>

                                    {/* INDEX */}
                                    <td>{index + 1}</td>

                                    {/* TRACKING */}
                                    <td>
                                        <div className="oms-customer">{user?.firstName}</div>
                                    </td>


                                    {/* CUSTOMER */}
                                    <td>
                                        <div className="oms-customer" >
                                            {user?.lastName}
                                        </div>
                                    </td>

                                    {/* CITY */}
                                    <td>
                                        <div className="oms-track-id" title={user?.firstName}>
                                            {user?.userName}
                                        </div>
                                    </td>


                                    {/* QTY */}
                                    <td>
                                        <div style={{ fontSize: 12, color: "white" }}>
                                            {user?.company_pin}
                                        </div>
                                    </td>
                                    {/* QTY */}

                                    <td>
                                        <div style={{ fontSize: 12, color: "white" }}>

                                            {user?.role === "admin" ? (
                                                <div style={{ fontSize: 11, color: "var(--gold)", marginTop: 2 }}>★ {user?.role}</div>
                                            ) :
                                                <div style={{ fontSize: 11, color: "var(--gold)", marginTop: 2 }}> {user?.role}</div>
                                            }

                                        </div>
                                    </td>


                                    {/* STATUS CHANGE DROPDOWN */}
                                    <td>
                                        <div className="oms-actions">

                                            <>
                                                <div className="oms-icon-btn print" title="Print Slip"
                                                    onClick={() => handleEdit(user)}
                                                >
                                                    <FaPencil size={10} />

                                                    {/* 🖨 */}
                                                </div>
                                            </>



                                            <div className="oms-icon-btn cancel" title="Delete User"
                                                onClick={() => {
                                                    setSelectedUser(user)
                                                    setShowDeleteModal(true)
                                                }}
                                            >
                                                <FaTrash size={10} />
                                            </div>


                                        </div>
                                    </td>
                                </tr>
                            ))}
                        </tbody>
                    </table>
                )}
            </div>

            {/* ✅ SINGLE MODAL */}
            <EditUserModal
                showModal={showModal}
                setShowModal={setShowModal}
                editData={editData}
                setEditData={setEditData}
                handleSubmit={handleSubmit}
                loading={loading}
                isEdit={isEdit}
            />

            <DeleteOrderModal
                showDeleteModal={showDeleteModal}
                setShowDeleteModal={setShowDeleteModal}
                selectedOrder={selectedUser}
                handleConfirmDelete={handleConfirmDelete}
                loading={loading}
            />

        </div>
    )
}

export default User